import script from "./RecommendedVendor03.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedVendor03.vue?vue&type=script&setup=true&lang=js"

import "./RecommendedVendor03.vue?vue&type=style&index=0&id=2b85b46a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b85b46a"]])

export default __exports__